<template>
  <div class="confirmation-row" @click="$emit('edit')">
    <div class="confirmation-label">
      {{ label }}
    </div>

    <div class="confirmation-value">
      {{ value || "—" }}
    </div>

    <v-btn
      icon
      small
      :color="insurer.color"
      class="confirmation-edit"
      @click.stop="$emit('edit')"
    >
      <v-icon small>mdi-pencil</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ConfirmationItem",

  props: {
    label: String,
    value: String,
    insurer: Object,
  },
};
</script>

<style scoped>
.confirmation-row {
  display: flex;
  align-items: center;
  min-height: 48px;
  padding: 8px 12px;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.confirmation-row:hover {
  background-color: #f5f5f5;
}

.confirmation-label {
  width: 130px;
  font-weight: 500;
  color: #424242;
  font-size: 0.875rem;
}

.confirmation-value {
  flex: 1;
  color: #212121;
  font-size: 0.875rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.confirmation-edit {
  margin-left: 8px;
}
</style>
